import classnames from 'classnames';
import styles from './index.module.less';
import modifiersToClassNames from '../../../core/modifiersToClassNames';
import type { Size } from '../../../core/enums';
import { BackgroundImage } from '../../atoms/background-image';
import { CardArt } from '../../atoms/card-art';
import Element from '../../../core/Element';

interface ImageWithCardArtProps {
  data: {
    backgroundImage: string;
    cardImage: string;
    cardImageAlt?: string;
  };
  $backgroundSize?: number;
  $position?: 'top' | 'right' | 'bottom' | 'left' | 'center';
  $cardSize?: Size;
  $flipBackgroundImage?: boolean;
  $gradient?: 'light' | 'dark';
  customization?: {
    backgroundImagePosition?: {
      horizontal?: 'left' | 'center' | 'right';
      vertical?: 'top' | 'center' | 'bottom';
    };
  };
  qeId?: string;
}

const getStyles = (
  $position: 'top' | 'right' | 'bottom' | 'left' | 'center',
  $backgroundSize: number
): { width: string } | { height: string } | Record<string, never> => {
  if ($position === 'center') {
    return {};
  }

  if ($position === 'left' || $position === 'right') {
    return { width: `${$backgroundSize}%` };
  }

  return { height: `${$backgroundSize}%` };
};

export const ImageWithCardArt = ({
  data,
  $backgroundSize = 75,
  $position = 'left',
  $cardSize,
  $flipBackgroundImage = false,
  $gradient,
  customization = {
    backgroundImagePosition: {},
  },
  qeId = 'ImageWithCardArt',
}: ImageWithCardArtProps) => (
  <Element qeId={qeId} className={styles.root}>
    {/* Background Image */}
    <Element
      className={classnames(
        styles.backgroundImage,
        modifiersToClassNames(styles, {
          $backgroundImagePosition: $position,
          $backgroundImageFlip: $flipBackgroundImage,
        })
      )}
      style={getStyles($position, $backgroundSize)}
    >
      <div className={styles.backgroundImage}>
        <BackgroundImage
          imageUrl={data.backgroundImage}
          $horizontalPosition={
            customization?.backgroundImagePosition?.horizontal
          }
          $verticalPosition={customization?.backgroundImagePosition?.vertical}
          $fullWidth
        />
        {$gradient && (
          <div
            className={classnames(
              styles.gradient,
              modifiersToClassNames(styles, {
                $gradient,
                $gradientPosition: $position,
              })
            )}
          />
        )}
      </div>
    </Element>

    {/* Card Art */}
    <div
      className={classnames(
        styles.card,
        modifiersToClassNames(styles, {
          $cardPosition: $position,
        })
      )}
    >
      <CardArt
        src={data.cardImage}
        alt={data.cardImageAlt ?? ''}
        $size={$cardSize}
      />
    </div>
  </Element>
);
